export const QUERY_COMMON_KEY = 'common'
export const QUERY_ROLE_KEY = 'role'
